import { Component, OnInit, ViewChild } from '@angular/core'
import { Router } from '@angular/router'
import { MyClientsCriteria } from '../../models/my-clients-criteria'
import { EnrollmentReportSummaryModel } from '../../models/enrollment-report-summary.model'
import { jqxGridComponent } from 'jqwidgets-ng/jqxgrid'
import * as _ from 'lodash'
import * as moment from 'moment'
import { ExcelService } from '../../excel.service'
import { ReportsGateway } from '../../gatewasys/reports.gateway'
import { TempidcardGateway } from '../../../tempID-card/gateways/tempID-gateway'
import { PortalGlobals } from '../../../portalglobals'
import { UserDataService } from '../../../user-management/gateways/user-data-service'

@Component({
    selector: 'EnrollmentsSummary',
    templateUrl: 'enrollments-summary.component.html'
})
export class EnrollmentsSummaryComponent implements OnInit {
    public loading = false
    width: number = 1240
    downloadError: string
    isSummary: boolean = true
    myClientsCriteria: MyClientsCriteria
    wesLastAccessDate: string
    totalCount: number
    chunkSize: number = 10000
    enrollmentSummary: EnrollmentReportSummaryModel[] = [] as EnrollmentReportSummaryModel[]
    @ViewChild('TreeGrid', { static: true }) summaryGrid: jqxGridComponent
    jqx: any

    source: any
    skipCall: boolean
    showTempCardLink: boolean = true
    dataAdapter: any

    rendergridrows = (params: any): any[] | undefined => {
        if (!isNaN(params.startindex)) {
            this.myClientsCriteria.PageNumber = Math.floor(params.startindex / this.myClientsCriteria.PageSize) + 1
            if (!this.skipCall) {
                this.enrollmentSummary = this._reportsGateway.getEnrollmentReportSummarySync(this.myClientsCriteria)
                this.enrollmentSummary.map((row) => {
                    row.DateofEnrollment = moment(row.DateofEnrollment).format('MM/DD/YYYY')
                    row.CoverageEffectiveDate = moment(row.CoverageEffectiveDate).format('MM/DD/YYYY')
                })
            }
            return this.enrollmentSummary
        }
    }

    cellsRenderer = function (row, columnfield, value, id) {
        return '<div class="jqx-grid-cell-left-align"><a style="vertical-align: middle;">' + value + '</a></div>'
    }

    ngOnInit() {
        ;(<HTMLElement>document.getElementsByClassName('search-criteria')[0]).style.display = 'none'
        this.loading = true
        this.skipCall = true
        this.myClientsCriteria = this._reportsGateway.myClientsCriteria
        this.myClientsCriteria.SortFields = ''
        this.myClientsCriteria.FilterCriteria = ''
        this.myClientsCriteria.PageNumber = 1
        this.source = {
            dataFields: [
                { name: 'TotalCount', type: 'number' },
                { name: 'DateofEnrollment', type: 'date' },
                { name: 'ApplicantHICN', type: 'string' },
                { name: 'ApplicantFirstName', type: 'string' },
                { name: 'ApplicantMiddleInitial', type: 'string' },
                { name: 'ApplicantLastName', type: 'string' },
                { name: 'ApplicantPhoneNumber', type: 'string' },
                { name: 'MemberStatusCode', type: 'string' },
                { name: 'Description', type: 'string' },
                { name: 'CoverageEffectiveDate', type: 'date' },
                { name: 'PBPID', type: 'string' },
                { name: 'ConfirmationNumber', type: 'string' },
                { name: 'TierTranslation', type: 'string' },
                { name: 'SubscriberId', type: 'string' },
                { name: 'Name', type: 'string' },
                { name: 'EnrollmentRecId', type: 'number' },
                { name: 'SourceId', type: 'string' },
                { name: 'AgentUserName', type: 'string' }
            ],
            datatype: 'array',
            localdata: {},
            totalrecords: this.totalCount,
            pagenum: 0
        }
        this.dataAdapter = new jqx.dataAdapter(this.source)
        this.populateGrid()
        this._reportsGateway.getWESLastAccess().subscribe(
            (date) => {
                this.wesLastAccessDate = date
            },
            (err) => {
                this.loading = false
            }
        )

        if (this._global.selectedPlanYear === 2020) {
            this.showTempCardLink = false
        }

        if (this._global.selectedPlanYear === 0) {
            this.userdataservice.currentYear.subscribe((data) => {
                this._global.selectedPlanYear = data
                if (data !== undefined && data !== 0 && data === 2020) {
                    this.showTempCardLink = false
                }
            })
        }
    }

    populateGrid() {
        this.myClientsCriteria = JSON.parse(localStorage.getItem('clientCriteria')!)
        this._reportsGateway.getEnrollmentReportSummary(this.myClientsCriteria).subscribe(
            (summary) => {
                if (summary !== null || summary !== undefined) {
                    if (summary.length > 0) {
                        summary.map((row) => {
                            row.DateofEnrollment = moment(row.DateofEnrollment).format('MM/DD/YYYY')
                            row.CoverageEffectiveDate = moment(row.CoverageEffectiveDate).format('MM/DD/YYYY')
                        })
                        this.totalCount = this.source.totalrecords = summary[0].TotalCount
                    } else this.totalCount = 0

                    this.enrollmentSummary = summary
                    this.source.localdate = summary
                    this.dataAdapter.dataBind()
                    this.summaryGrid.updatebounddata()
                    this.loading = false
                    this.skipCall = false
                } else {
                    this.loading = false
                }
            },
            (error) => {
                this.loading = false
            }
        )
    }

    columns: any[] = [
        {
            text: 'Application Date',
            dataField: 'DateofEnrollment',
            width: 100,
            cellsformat: 'd',
            cellsrenderer: this.cellsRenderer
        },
        {
            text: 'Effective Date',
            dataField: 'CoverageEffectiveDate',
            width: 90,
            cellsformat: 'd'
        },
        { text: 'Agent ID', dataField: 'AgentUserName', width: 110 },
        { text: 'Agent Name', dataField: 'Name', width: 120 },
        { text: 'Applicant First Name', dataField: 'ApplicantFirstName', width: 125 },
        { text: 'Applicant Last Name', dataField: 'ApplicantLastName', width: 125 },
        { text: 'G ID Number', dataField: 'SubscriberId', width: 120 },
        { text: 'Medicare Number', dataField: 'ApplicantHICN', width: 100 },
        { text: 'Plan', dataField: 'TierTranslation', width: 120 },
        { text: 'Status', dataField: 'Description', width: 230 }
    ]

    ready = (): void => {
        let localizationObject = {
            filterstringcomparisonoperators: ['equal', 'not equal'],
            // filter numeric comparison operators.
            filternumericcomparisonoperators: ['less than or equal', 'equal', 'greater than or equal'],
            // filter date comparison operators.
            filterdatecomparisonoperators: ['less than or equal', 'equal', 'greater than or equal'],
            // filter bool comparison operators.
            filterbooleancomparisonoperators: ['equal', 'not equal']
        }
        this.summaryGrid.localizestrings(localizationObject)
    }

    onFilter(event: any): void {
        if (!this.skipCall) {
            this.skipCall = true
            this.myClientsCriteria = JSON.parse(localStorage.getItem('clientCriteria')!)
            let filterinfo = this.summaryGrid.getfilterinformation()
            let criteria = ''
            for (let i = 0; i < filterinfo.length; i++) {
                let field = filterinfo[i].filtercolumn
                let filters = filterinfo[i].filter.getfilters()
                let operator = filters[0].operator === 0 ? ' AND ' : ' OR '
                criteria += criteria === '' ? '(' : ' AND ('
                let subCriteria = ''
                for (let filter of filters) {
                    if (subCriteria !== '') {
                        subCriteria += operator
                    }
                    if (filter.condition === 'LESS_THAN_OR_EQUAL') {
                        if (filter.type === 'numericfilter') {
                            subCriteria += `${field} <= ${filter.value}`
                        } else if (filter.type === 'datefilter') {
                            subCriteria += `${field} <= '${filter.value}'`
                        }
                    } else if (filter.condition === 'GREATER_THAN_OR_EQUAL') {
                        if (filter.type === 'numericfilter') {
                            subCriteria += `${field} >= ${filter.value}`
                        } else if (filter.type === 'datefilter') {
                            subCriteria += `${field} >= '${filter.value}'`
                        }
                    } else if (filter.condition === 'EQUAL') {
                        subCriteria += `${field} = '${filter.value}'`
                    } else if (filter.condition === 'NOT_EQUAL') {
                        subCriteria += `${field} != '${filter.value}'`
                    }
                }
                criteria += subCriteria + ')'
            }

            this.myClientsCriteria.FilterCriteria = criteria
            localStorage.setItem('clientCriteria', JSON.stringify(this.myClientsCriteria))
            this.loading = true

            this.populateGrid()
        }
    }

    Cellclick(event: any): void {
        if (event.args.datafield === 'DateofEnrollment') {
            this.myClientsCriteria.EnrollmentRecId = event.args.row.bounddata.EnrollmentRecId
            this.myClientsCriteria.SourceId = event.args.row.bounddata.SourceId
            localStorage.setItem('summaryCriteria', JSON.stringify(this.myClientsCriteria))
            const insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()
            this._routers.navigateByUrl('/' + insCo + '/reports/my-clients/enrollment-details')
        }
    }

    onSort(event: any): void {
        if (!this.skipCall) {
            this.skipCall = true
            //  this.myClientsCriteria.SortFields = this.jqx.onSort(event)
            this.myClientsCriteria = JSON.parse(localStorage.getItem('clientCriteria')!)
            let sortinformation = event.args.sortinformation
            let sortdirection = sortinformation.sortdirection.ascending ? 'ASC' : 'DESC'
            if (!sortinformation.sortdirection.ascending && !sortinformation.sortdirection.descending) {
                sortdirection = ''
            }
            if (sortdirection) {
                this.myClientsCriteria.SortFields = `${sortinformation.sortcolumn} ${sortdirection}`
            } else {
                this.myClientsCriteria.SortFields = ''
            }
            localStorage.setItem('clientCriteria', JSON.stringify(this.myClientsCriteria))
            this.populateGrid()
            //  this.skipCall = false
        }
    }

    onPageSizeChanged(event: any): void {
        if (!this.skipCall) {
            this.skipCall = true
            let args = event.args
            this.myClientsCriteria.PageSize = args.pagesize
            this.populateGrid()
        }
    }

    updatefilterconditions = (type: string, defaultconditions: any): string[] | undefined => {
        let stringcomparisonoperators = ['EQUAL', 'NOT_EQUAL']
        let numericcomparisonoperators = ['LESS_THAN_OR_EQUAL', 'EQUAL', 'GREATER_THAN_OR_EQUAL']
        let datecomparisonoperators = ['LESS_THAN_OR_EQUAL', 'EQUAL', 'GREATER_THAN_OR_EQUAL']
        let booleancomparisonoperators = ['EQUAL', 'NOT_EQUAL']
        switch (type) {
            case 'stringfilter':
                return stringcomparisonoperators
            case 'numericfilter':
                return numericcomparisonoperators
            case 'datefilter':
                return datecomparisonoperators
            case 'booleanfilter':
                return booleancomparisonoperators
        }
    }

    constructor(
        private _routers: Router,
        private _excelService: ExcelService,
        private _tempIDCardGateway: TempidcardGateway,
        private _reportsGateway: ReportsGateway,
        public _global: PortalGlobals,
        private userdataservice: UserDataService
    ) {}

    onExport() {
        this.loading = true
        let pageNumber = this.myClientsCriteria.PageNumber
        let pageSize = this.myClientsCriteria.PageSize
        this.myClientsCriteria.PageNumber = 1
        this.myClientsCriteria.PageSize = this.totalCount
        this.openWindowWithPost('/Reports/MyClientsSummary.aspx', this.myClientsCriteria)
        this.loading = false
        //this._reportsGateway.getEnrollmentReportSummary(this.myClientsCriteria)
        //    .subscribe(summary => {
        //        if ((summary !== null || summary !== undefined) && summary.length > 0) {
        //            summary.map(row => {
        //                row.DateofEnrollment = moment(row.DateofEnrollment).format('MM/DD/YYYY')
        //                row.CoverageEffectiveDate = moment(row.CoverageEffectiveDate).format('MM/DD/YYYY')
        //            })
        //            let array = _.clone(summary)
        //            array.forEach(function (v) {
        //                delete v.TotalCount
        //                delete v.ApplicantMiddleInitial
        //                delete v.ApplicantPhoneNumber
        //                delete v.PBPID

        //                delete v.MemberStatusCode
        //                delete v.EnrollmentRecId
        //                delete v.SourceId
        //            })
        //            let strArray = JSON.stringify(array)
        //            strArray = strArray.replace(/DateofEnrollment/g, 'Application Date')
        //            strArray = strArray.replace(/CoverageEffectiveDate/g, 'Effective Date')
        //            strArray = strArray.replace(/AgentUserName/g, 'Agent ID')
        //            strArray = strArray.replace(/ApplicantFirstName/g, 'Applicant First Name')
        //            strArray = strArray.replace(/ApplicantLastName/g, 'Applicant Last Name')
        //            strArray = strArray.replace(/"Name"/g, '"Agent Name"')
        //            strArray = strArray.replace(/SubscriberId/g, 'G ID Number')
        //            strArray = strArray.replace(/ApplicantHICN/g, 'Medicare Number')
        //            strArray = strArray.replace(/TierTranslation/g, 'Plan')
        //            strArray = strArray.replace(/Description/g, 'Status')

        //            strArray = strArray.replace(/ConfirmationNumber/g, 'Confirmation Number')
        //            strArray = strArray.replace(/ApplicantState/g, 'Applicant State')
        //            strArray = strArray.replace(/MailingAddress1/g, 'Mailing Address Line1')
        //            strArray = strArray.replace(/MailingAddress2/g, 'Mailing Address Line2')
        //            strArray = strArray.replace(/MailingCity/g, 'Mailing City')
        //            strArray = strArray.replace(/MailingState/g, 'Mailing State')
        //            strArray = strArray.replace(/MailingZipCode/g, 'Mailing Zip Code')
        //            strArray = strArray.replace(/ElectionType/g, 'Election Type')
        //            strArray = strArray.replace(/LanguageType/g, 'Language Code')
        //            strArray = strArray.replace(/PremiumSource/g, 'PWO Premium Source Code')
        //            strArray = strArray.replace(/UnpaidPremiumBalance/g, 'Unpaid Premium Balance')
        //            strArray = strArray.replace(/CoverageTerminationDate/g, 'Coverage Termination Date')
        //            strArray = strArray.replace(/DisenrollmentReason/g, 'Disenrollment Reason Description')
        //            strArray = strArray.replace(/DexMethodCode/g, 'DEX Method Code/Agent Enroll Method Code')
        //            strArray = strArray.replace(/OriginalMemberEffDate/g, 'Member Original Effective Date')
        //            let modSummary = JSON.parse(strArray)
        //            this._excelService.exportAsExcelFile(modSummary, 'My Clients Summary Report')
        //            this.myClientsCriteria.PageNumber = pageNumber
        //            this.myClientsCriteria.PageSize = pageSize
        //            this.loading = false

        //        } else {
        //            this.loading = false
        //        }
        //    },
        //    (error) => {
        //        this.loading = false
        //    })
    }

    openWindowWithPost(url: string, data: any): void {
        var form = document.createElement('form')
        form.target = '_blank'
        form.method = 'POST'
        form.action = url
        form.style.display = 'none'

        for (var key in data) {
            var input = document.createElement('input')
            input.type = 'hidden'
            input.name = key
            if (key === 'ApplicationStartDate' || key === 'ApplicationEndDate') {
                input.value = JSON.stringify(data[key])
            } else {
                input.value = data[key]
            }

            form.appendChild(input)
        }

        document.body.appendChild(form)
        form.submit()
        document.body.removeChild(form)
    }

    onPrint() {
        let gridContent = this.summaryGrid.exportdata('html')
        let newWindow = window.open('', '', 'width=800, height=500'),
            document = newWindow?.document.open(),
            pageContent =
                '<!DOCTYPE html>\n' +
                '<html>\n' +
                '<head>\n' +
                '<meta charset="utf-8" />\n' +
                '<title>Enrollments Summary</title>\n' +
                '</head>\n' +
                '<body>\n' +
                gridContent +
                '\n</body>\n</html>'
        document?.write(pageContent)
        document?.close()
        newWindow?.print()
    }

    onBack() {
        const insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()
        this._routers.navigateByUrl('/' + insCo + '/reports/my-clients/counts')
    }

    onGetTemporaryIDCard(): any {
        this.downloadTempIDCard()
    }

    downloadTempIDCard() {
        let ParentName: string
        let SectionName: string
        ParentName = 'TEMPID'
        SectionName = 'TEMPID'
        this._tempIDCardGateway.DownloadPDF(ParentName, SectionName).subscribe((model: any) => {
            var binaryString = window.atob(model)
            var binaryLen = binaryString.length
            console.log('binaryLen' + binaryLen)
            if (binaryLen == 3) {
                console.log('File doesnt exist / some back ground  error')
                this.downloadError = 'File Not Found'
                return
            }
            this.downloadError = ''
            var bytes = new Uint8Array(binaryLen)
            for (var i = 0; i < binaryLen; i++) {
                var ascii = binaryString.charCodeAt(i)
                bytes[i] = ascii
            }

            let fileName = 'Temp ID Card'
            // below code needed for ie browser
            if (window.navigator && (window.navigator as any).msSaveOrOpenBlob) {
                ;(window.navigator as any).msSaveOrOpenBlob(new Blob([bytes], { type: 'application/pdf' }), fileName)
            }
            // for other browsers
            var fileURL = URL.createObjectURL(new Blob([bytes], { type: 'application/pdf' }))
            window.open(fileURL)
        })
    }
}
